import { useEffect, useRef } from 'react';
import { useSecondTick } from './useSecondTick';

// Seconds since `key` became current. Restarts when `key` changes; idle when
// it's undefined. The start stamp is taken in an effect — Date.now() during
// render trips react-hooks/purity.
export const useElapsedSeconds = (key: string | undefined): number => {
  const startedAt = useRef<Map<string, number>>(new Map());
  const now = useSecondTick(!!key);

  useEffect(() => {
    if (key && !startedAt.current.has(key)) {
      startedAt.current.set(key, Date.now());
    }
  }, [key]);

  if (!key || now === 0) return 0;
  const start = startedAt.current.get(key);
  return start ? Math.max(0, Math.floor((now - start) / 1000)) : 0;
};
